import DialogTitle from '@material-ui/core/DialogTitle'
import { Grid, Typography } from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import React, { useCallback, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import DraggablePaper from 'civic-champs-shared/core/confirm-dialog/DraggablePaper'
import { Field, Form, Formik } from 'formik'
import OutlinedButton from 'civic-champs-shared/core/OutlinedButton'
import ContainedButton from 'civic-champs-shared/core/ContainedButton'
import yup from 'civic-champs-shared/utils/yup'
import { CkEditorStyledField } from 'civic-champs-shared/formik/components/CkEditorStyledField'

const useStyles = makeStyles({
  title: { cursor: 'move', padding: '20px 20px 16px 20px' },
  content: {
    display: 'flex',
    padding: '0 20px !important',
    gap: '14px',
    alignItems: 'stretch',
    overflowY: 'hidden',
  },
  editorContainer: {
    width: '100%',
  },
  label: {
    fontFamily: 'Nunito, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.1px',
    color: '#000000',
    margin: 0,
    padding: 0,
  },
  header: {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000000',
  },
  actions: {
    padding: '8px 20px 20px',
  },
  container: {
    width: '700px',
    maxWidth: '100%',
    background: '#F8FAFF',
    boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)',
    borderRadius: '5px',
  },
  limit: {
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'right',
    letterSpacing: '0.1px',
    color: '#8E9192',
    display: 'block',
    width: '100%',
  },
})

const instructionsSchema = yup.object({
  content: yup.string().trim().nullable().max(2000),
})

export default function EditGroupApplicationInstructionsDialog(props) {
  const { showing, complete, close, title, initialValue = '' } = props
  const classes = useStyles()
  const initialValues = useMemo(() => ({ content: initialValue || '' }), [initialValue])

  const handleSubmit = useCallback(
    input => {
      return complete(instructionsSchema.cast(input))
    },
    [complete],
  )

  return (
    <Dialog
      open={showing}
      onClose={() => close()}
      PaperComponent={DraggablePaper}
      PaperProps={{ handle: `#edit-group-application-instructions-dialog`, className: classes.container }}
      aria-labelledby="edit-group-application-instructions-dialog-title"
    >
      <DialogTitle
        classes={{ root: classes.title }}
        disableTypography={true}
        id="edit-group-application-instructions-dialog"
      >
        <Grid container direction="row" alignItems="center" justify="space-between">
          <Grid item>
            <Typography classes={{ root: classes.header }}>Edit {title}</Typography>
          </Grid>
          <Grid item>
            <CloseIcon fontSize="small" style={{ cursor: 'pointer' }} onClick={close} />
          </Grid>
        </Grid>
      </DialogTitle>
      <Formik initialValues={initialValues} validationSchema={instructionsSchema} onSubmit={handleSubmit}>
        {({ submitForm, isSubmitting, values }) => {
          return (
            <Form style={{ width: '100%' }}>
              <DialogContent classes={{ root: classes.content }}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography className={classes.label}>Content</Typography>
                    <div className={classes.editorContainer}>
                      <Field
                        fullWidth
                        name="content"
                        component={CkEditorStyledField}
                        id="group-application-instructions-editor"
                        _dangerouslyRemoveDialogTabindex
                        marginless
                        smaller
                        multiline
                        rows={12}
                        maxLength={2000}
                      />
                    </div>
                    {values.content.length >= 1500 && (
                      <span className={classes.limit} style={values.content.length >= 2000 ? { color: '#BA1B1B' } : {}}>
                        {values.content.length}/2000
                      </span>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions className={classes.actions}>
                <Grid container direction="row" alignItems="center" justify="space-between">
                  <OutlinedButton disabled={isSubmitting} onClick={close}>
                    Cancel
                  </OutlinedButton>
                  <ContainedButton disabled={isSubmitting} onClick={submitForm}>
                    Save
                  </ContainedButton>
                </Grid>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
